<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1>Signature Email Custom</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">

        <v-stepper v-model="step" vertical>
          <v-stepper-step editable :complete="step > 1" step="1">
            Coordonnées
            <small>Summarize if needed</small>
          </v-stepper-step>

          <v-stepper-content step="1">
<!--            <v-card color="grey lighten-1" class="mb-12" height="200px"></v-card>-->
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model="firstname"
                :rules="nameRules"
                :counter="20"
                label="Prénom"
                required
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model="lastname"
                :rules="nameRules"
                :counter="20"
                label="Nom"
                required
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model="email"
                :rules="emailRules"
                label="E-mail"
                required
              ></v-text-field>

              <v-switch
                v-model="adressDouble"
                :label="'Double adresse ?'"
              ></v-switch>

            </v-col>
            <v-btn color="primary" @click="step = 2">Suivant</v-btn>
            <!--          <v-btn text>Cancel</v-btn>-->
          </v-stepper-content>

          <v-stepper-step editable :complete="step > 2" step="2">Configure analytics for this app</v-stepper-step>

          <v-stepper-content step="2">
            <v-card color="grey lighten-1" class="mb-12" height="200px"></v-card>
            <v-btn color="primary" @click="step = 3">Suivant</v-btn>
            <v-btn text>Cancel</v-btn>
          </v-stepper-content>

          <v-stepper-step editable :complete="step > 3" step="3">Select an ad format and name ad unit</v-stepper-step>

          <v-stepper-content step="3">
            <v-card color="grey lighten-1" class="mb-12" height="200px"></v-card>
            <v-btn color="primary" @click="step = 4">Suivant</v-btn>
            <v-btn text>Cancel</v-btn>
          </v-stepper-content>

          <v-stepper-step editable step="4">View setup instructions</v-stepper-step>
          <v-stepper-content step="4">
            <v-card color="grey lighten-1" class="mb-12" height="200px"></v-card>
            <v-btn color="primary" @click="step = 1">Suivant</v-btn>
            <v-btn text>Cancel</v-btn>
          </v-stepper-content>
        </v-stepper>
      </v-col>
      <v-col cols="6">
      <div id="preview">
        <span>{{ firstname }}</span>&nbsp;<span>{{ lastname }}</span>
      </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'EmailSignatureCustom',
  data: () => ({
    step: 1,
    valid: false,
    firstname: '',
    lastname: '',
    adressDouble: false,
    nameRules: [
      v => !!v || 'Nom Requis'
    ],
    email: '',
    emailRules: [
      v => !!v || 'E-mail est requis',
      v => /.+@.+/.test(v) || 'E-mail must be valid'
    ]
  })
}
</script>

<style scoped>

</style>
